
const TruncatedText = ({ children }) => {
  return <div className="truncated-text">{children}</div>;
};

export default TruncatedText;
